// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:940px){.contract-date__date[data-v-5b1e251b]{flex:0 0 auto}.contract-date label.contract-date__immigrant[data-v-5b1e251b],.contract-date__date[data-v-5b1e251b]{margin:0 0 20px;width:250px}.contract-location[data-v-5b1e251b]{width:250px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
